import { useMemo } from 'react';
export function useForkRef(refA, refB) {
    return useMemo(function () {
        if (!refA && !refB) {
            return null;
        }
        return function (refValue) {
            if (refA)
                setRef(refA, refValue);
            if (refB)
                setRef(refB, refValue);
        };
    }, [refA, refB]);
}
function setRef(ref, value) {
    if (typeof ref === 'function') {
        ref(value);
    }
    else if (ref) {
        // eslint-disable-next-line no-extra-semi
        ;
        ref.current = value;
    }
}
